import api from '@/api'

export default {
  file_update_start (data) {
    return api({
      method: 'POST',
      url: '/breakpoint/upload/start',
      params:data
    })
  },
  async file_update_slice (data) {
    return api({
      method: 'POST',
      url: '/breakpoint/upload/uploadSlice',
      data
    })
  },
  async file_update_complete (data) {
    return api({
      method: 'POST',
      url: '/breakpoint/upload/complete',
      params:data
    })
  },
}
